import { Option, SelectValue } from './Select';

export const getLabelFromValue = (
  value: SelectValue | null | undefined,
  optionsArray: Option[]
): React.ReactText => {
  const option = optionsArray.find(o => o.value === value);
  return (
    (option && option.label) ||
    (typeof value === 'number' && value.toString()) ||
    value ||
    ''
  );
};

export const getEnumValues = (enumObject: Record<number, string>): number[] =>
  Object.keys(enumObject)
    .map(key => parseInt(key, 10))
    .filter(key => !Number.isNaN(key));

export const getEnumOptions = (
  enumObject: Record<number, string>,
  translations: Record<number, string>
): Option[] => {
  return getEnumValues(enumObject).map(value => {
    return {
      value,
      label: translations[value] || enumObject[value],
    };
  });
};

export const getObjectOptions = (
  object: Record<string, string>,
  translations: Record<string, string>
): Option[] =>
  Object.values(object).map(value => {
    return { value, label: translations[value] || object[value] };
  });

export const getObjectOptionsByKeys = (
  object: Record<string, string>,
  translations: Record<string, string>
): Option[] =>
  Object.keys(object).map(value => {
    return { value, label: translations[value] || object[value] };
  });
